module.exports = __webpack_public_path__ + "img/IMG_2495-2.6b269132.jpg";